<template>
    <AdminLayout>
        <div class="table-container px-4">
            <div class="rows-header">
                <div class="d-flex justify-content-end">
                    <PaginationComp :current-page="response.currentPage" :total-pages="response.totalPages"
                        :total-rows="response.totalRows" :rows-per-page="response.rowsPerPage"
                        :has-previous="response.hasPrevious" :has-next="response.hasNext" :max-visible-pages="5"
                        :show-info="true" :show-page-numbers="true" :show-rows-per-page="true" :show-go-to-page="true"
                        :rows-per-page-options="[10, 25, 50, 100, 250, 500]" @page-changed="handlePageChange"
                        @rows-per-page-changed="handleRowsPerPageChange" />
                </div>
            </div>

            <form @submit.prevent="handleSubmit" class="h-100">
                <div class="table-section">
                    <table class="table table-hover table-sm align-middle">
                        <thead style="position: sticky; top: 0; z-index: 10;">
                            <tr>
                                <th>User</th>
                                <th>Username</th>
                                <th>Remarks</th>
                                <th>Amount</th>
                                <th>Type</th>
                                <th>Status</th>
                                <th>Issued</th>
                                <th>Created</th>
                            </tr>
                            <tr>
                                <th>
                                    <input class="form-control" v-model="searchModel.fullname_user" />
                                </th>
                                <th>
                                    <input class="form-control" v-model="searchModel.username_user" />
                                </th>
                                <th>
                                    <input class="form-control" v-model="searchModel.remarks_ucf" />
                                </th>
                                <th>
                                    <input class="form-control" v-model="searchModel.amount_ucf" />
                                </th>
                                <th>
                                    <input class="form-control" v-model="searchModel.module_ucf" />
                                </th>
                                <th>
                                    <input class="form-control" v-model="searchModel.status_ucf" />
                                </th>
                                <th>
                                    <input class="form-control" v-model="searchModel.dateissued_ucf" />
                                </th>
                                <th>
                                    <input class="form-control" v-model="searchModel.dateadded_ucf" />
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="isSearching">
                                <TableSkeleton :columns="12" />
                            </template>
                            <template v-else-if="response?.cashflows?.length === 0">
                                <EmptyTable :colspan="12" />
                            </template>
                            <template v-else>
                                <tr v-for="cashflow in response.cashflows" :key="cashflow.syspk_ucf">
                                    <td>{{ cashflow.fullname_user }}</td>
                                    <td>{{ cashflow.username_user }}</td>
                                    <td>{{ cashflow.remarks_ucf }}</td>
                                    <td>{{ cashflow.amount_ucf }}</td>
                                    <td>{{ cashflow.module_ucf }}</td>
                                    <td>{{ cashflow.status_ucf }}</td>
                                    <td>{{ cashflow.dateissued_ucf }}</td>
                                    <td>{{ cashflow.dateadded_ucf }}</td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
                <button type="submit" class="d-none">Submit</button>
            </form>
        </div>


    </AdminLayout>
</template>

<script setup>
import EmptyTable from '@/components/animations/EmptyTable.vue';
import TableSkeleton from '@/components/animations/TableSkeleton.vue';
import PaginationComp from '@/components/commons/PaginationComp.vue';
import AdminLayout from '@/layouts/AdminLayout.vue';
import transactionService from '@/services/transactionService';
import { onMounted, ref } from 'vue';
const searchModel = ref({});
const isSearching = ref(false);
const response = ref({
    cashflows: [], // This will vary
    currentPage: 1,
    totalPages: 0,
    totalRows: 0,
    rowsPerPage: 100,
    hasPrevious: false,
    hasNext: false
});

const handlePageChange = (page) => {
    response.value.currentPage = page;
    search();
}

const handleRowsPerPageChange = (rowsPerPage) => {
    response.value.currentPage = 1;
    response.value.rowsPerPage = rowsPerPage;
    search();
}


const handleSubmit = () => {
    response.value.currentPage = 1;
    search();
}

const search = async () => {
    isSearching.value = true;
    response.value = await transactionService.searchCashflows(response.value.currentPage, response.value.rowsPerPage, searchModel.value);
    isSearching.value = false;
}

onMounted(() => {
    search();
});

</script>

<style scoped>
.table-section {
    background: white;
    border-radius: 16px;
    overflow: auto;
    box-shadow: 0 5px 25px rgba(220, 53, 69, 0.08);
    border: 1px solid rgba(220, 53, 69, 0.05);
    max-height: 85vh;
}


/* Container for the entire section */
.table-container {
    position: relative;
    height: 100vh;
    /* or whatever height you want */
    display: flex;
    flex-direction: column;
}

/* Freeze the Rows div */
.rows-header {
    position: sticky;
    top: 0;
    background: white;
    /* or your background color */
    z-index: 100;
    padding: 10px 0;
    border-bottom: 1px solid #dee2e6;
}

/* Make the table responsive container scrollable */
.table-responsive {
    flex: 1;
    overflow-y: auto;
    overflow-x: auto;
    position: relative;
}

/* Freeze the thead */
.table thead {
    position: sticky;
    top: 0;
    z-index: 50;
    background: white;
    /* or your background color */
}

.table thead th {
    background: white;
    /* or your background color */
    border-bottom: 2px solid #dee2e6;
}

/* If you want both rows of thead to stay */
.table thead tr {
    background: white;
    /* or your background color */
}

/* For the second thead row (filter inputs) */
.table thead tr:last-child th {
    background: white;
    /* or your background color */
    border-bottom: 1px solid #dee2e6;
}
</style>